import moment from "moment";
import "moment/locale/es";
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";
import {
  ETIQUETAS_REDONDEO,
  ETIQUETAS_TRIESTADO,
  ETIQUETAS_BASE_RECALCULO,
  ALCANCE,
} from "../Utils/reglasPrecio";

moment.locale("es");

const layoutTabla = {
  fillColor: (rowIndex) => {
    if (rowIndex === 0) return "#cccccc";
    return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
  },
  hLineWidth: function () { return 1; },
  vLineWidth: function () { return 1; },
  hLineColor: function () { return "#adaaaa"; },
  vLineColor: function () { return "#adaaaa"; },
};

const siNo = (valor) => (valor ? "Si" : "No");

// "-" y no vacio: distingue "no lo define, se hereda" de una celda en blanco.
const pct = (valor) =>
  valor === null || valor === undefined || valor === "" ? "-" : `${valor}%`;

const numero = (valor) =>
  valor === null || valor === undefined || valor === "" ? "-" : String(valor);

// Renglon de estado vacio: colSpan mas los placeholders que exige pdfmake.
const filaVacia = (columnas, texto) => [
  { text: texto, style: "textoTabla", colSpan: columnas, alignment: "center" },
  ...Array(columnas - 1).fill({}),
];

const configuracionListasDePreciosPdf = (values) => {
  const empresa = values.empresa;
  const logoBiwo = values.logoBiwo;
  const config = values.configuracion || {};
  const precios = values.precios || [];
  const reglas = values.reglas || [];
  const marcasExcluidas = values.marcasExcluidas || [];

  // ── 1. Banderas globales ───────────────────────────────────────────────────
  const filasConfiguracion = [
    [
      { text: "Calcular precios automaticamente:", style: "subheader" },
      { text: siNo(config.calcularPreciosAutomaticamente), style: "textoChico" },
      { text: "Calcular precios sobre:", style: "subheader" },
      { text: config.calcularPreciosSobre ? "Costo" : "Venta", style: "textoChico" },
    ],
    [
      { text: "No bajar precios automaticamente:", style: "subheader" },
      { text: siNo(config.noBajarPreciosAutomaticamente), style: "textoChico" },
      { text: "Bloquear costo:", style: "subheader" },
      { text: siNo(config.bloquearCosto), style: "textoChico" },
    ],
    [
      { text: "No vender abajo del costo:", style: "subheader" },
      { text: siNo(config.noVenderAbajoCosto), style: "textoChico" },
      { text: "Vender sin inventario:", style: "subheader" },
      { text: siNo(config.venderSinInventario), style: "textoChico" },
    ],
    [
      { text: "Precedencia de reglas:", style: "subheader" },
      {
        text: config.priorizarReglasTipoCliente
          ? "Lista base, luego cliente, y al final tipo de cliente (gana el tipo de cliente)"
          : "Lista base, luego tipo de cliente, y al final cliente (gana el cliente)",
        style: "textoChico",
        colSpan: 3,
      },
      {},
      {},
    ],
  ];

  // ── 2. Listas de precios ───────────────────────────────────────────────────
  const encabezadoListas = [
    { text: "Lista", style: "tituloTabla" },
    { text: "%", style: "tituloTabla" },
    { text: "Margen min", style: "tituloTabla" },
    { text: "Margen max", style: "tituloTabla" },
    { text: "Desc min", style: "tituloTabla" },
    { text: "Desc max", style: "tituloTabla" },
    { text: "Calculo auto", style: "tituloTabla" },
    { text: "Recalcular con", style: "tituloTabla" },
    { text: "No bajar", style: "tituloTabla" },
    { text: "Redondeo", style: "tituloTabla" },
    { text: "Factor piso", style: "tituloTabla" },
  ];

  const filasListas = precios.length
    ? precios.map((lista) => [
        { text: lista.nombre || "", style: "textoTabla" },
        { text: pct(lista.porcentaje), style: "textoTabla", alignment: "right" },
        { text: pct(lista.margenMinimo), style: "textoTabla", alignment: "right" },
        { text: pct(lista.margenMaximo), style: "textoTabla", alignment: "right" },
        { text: pct(lista.descuentoMinimo), style: "textoTabla", alignment: "right" },
        { text: pct(lista.descuentoMaximo), style: "textoTabla", alignment: "right" },
        {
          text: ETIQUETAS_TRIESTADO[Number(lista.calcularAutomaticamente) || 0],
          style: "textoTabla",
          alignment: "center",
        },
        {
          text: ETIQUETAS_BASE_RECALCULO[Number(lista.baseRecalculo) || 0],
          style: "textoTabla",
          alignment: "center",
        },
        {
          text: ETIQUETAS_TRIESTADO[Number(lista.noBajarPrecios) || 0],
          style: "textoTabla",
          alignment: "center",
        },
        {
          text: ETIQUETAS_REDONDEO[Number(lista.redondeo) || 0],
          style: "textoTabla",
          alignment: "center",
        },
        { text: numero(lista.factorPrecioPiso), style: "textoTabla", alignment: "right" },
      ])
    : [filaVacia(11, "No hay listas de precios configuradas")];

  // ── 3, 4 y 5. Reglas por alcance ───────────────────────────────────────────
  const encabezadoReglas = [
    { text: "Lista", style: "tituloTabla" },
    { text: "Aplica a", style: "tituloTabla" },
    { text: "Familia", style: "tituloTabla" },
    { text: "Marca", style: "tituloTabla" },
    { text: "%", style: "tituloTabla" },
    { text: "Margen min", style: "tituloTabla" },
    { text: "Margen max", style: "tituloTabla" },
    { text: "Desc min", style: "tituloTabla" },
    { text: "Desc max", style: "tituloTabla" },
    { text: "Observaciones", style: "tituloTabla" },
  ];

  const filaRegla = (regla) => [
    { text: regla.lista || "", style: "textoTabla" },
    { text: regla.aplicaA || "", style: "textoTabla" },
    { text: regla.familia || "Todas", style: "textoTabla" },
    { text: regla.marca || "Todas", style: "textoTabla" },
    { text: pct(regla.porcentaje), style: "textoTabla", alignment: "right" },
    { text: pct(regla.margenMinimo), style: "textoTabla", alignment: "right" },
    { text: pct(regla.margenMaximo), style: "textoTabla", alignment: "right" },
    { text: pct(regla.descuentoMinimo), style: "textoTabla", alignment: "right" },
    { text: pct(regla.descuentoMaximo), style: "textoTabla", alignment: "right" },
    { text: regla.observaciones || "", style: "textoTabla" },
  ];

  const tablaReglas = (titulo, lista, saltoDePagina) => [
    {
      text: titulo,
      margin: [0, 6, 0, 0],
      ...(saltoDePagina ? { pageBreak: "before" } : {}),
    },
    {
      style: "tableExample",
      table: {
        headerRows: 1,
        widths: ["12%", "16%", "10%", "10%", "7%", "8%", "8%", "7%", "8%", "14%"],
        body: [
          encabezadoReglas,
          ...(lista.length ? lista.map(filaRegla) : [filaVacia(10, "Sin reglas capturadas")]),
        ],
      },
      layout: layoutTabla,
    },
  ];

  const porAlcance = (alcance) =>
    reglas.filter((regla) => Number(regla.alcance) === alcance);

  const contenidoReglas = [
    ...tablaReglas("Reglas base de lista:", porAlcance(ALCANCE.LISTA)),
    ...tablaReglas("Reglas por tipo de cliente:", porAlcance(ALCANCE.TIPO_CLIENTE)),
  ];

  if (values.incluirReglasPorCliente) {
    contenidoReglas.push(
      ...tablaReglas("Reglas por cliente:", porAlcance(ALCANCE.CLIENTE), true)
    );
  }

  // ── 6. Escalas por cantidad ────────────────────────────────────────────────
  const reglasConEscalas = reglas.filter((regla) => (regla.escalas || []).length);
  const filasEscalas = reglasConEscalas.length
    ? reglasConEscalas.flatMap((regla) =>
        regla.escalas.map((escala) => [
          { text: regla.lista || "", style: "textoTabla" },
          { text: regla.aplicaA || "", style: "textoTabla" },
          { text: numero(escala.cantidadDesde), style: "textoTabla", alignment: "right" },
          {
            text: escala.cantidadHasta == null ? "Sin tope" : String(escala.cantidadHasta),
            style: "textoTabla",
            alignment: "right",
          },
          { text: pct(escala.descuentoMaximo), style: "textoTabla", alignment: "right" },
        ])
      )
    : [filaVacia(5, "Ninguna regla tiene escalas por cantidad")];

  // ── 7. Marcas excluidas del calculo automatico ─────────────────────────────
  const filasMarcas = marcasExcluidas.length
    ? marcasExcluidas.map((marca) => [
        { text: marca.clave || "", style: "textoTabla" },
        { text: marca.nombre || "", style: "textoTabla" },
      ])
    : [filaVacia(2, "Ninguna marca tiene apagado el calculo automatico")];

  const dd = {
    footer: {
      image: "logoBiwo",
      alignment: "center",
      width: 80,
    },
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          layout: { defaultBorder: false },
          body: [
            [
              ...HeaderEmpresaCard(empresa, false, false, {
                border: [false, false, false, false],
                table: {
                  headerRows: 1,
                  widths: ["100%"],
                  body: [
                    [{ text: "Fecha de Impresión:", style: "subheader", alignment: "center" }],
                    [
                      {
                        text: moment().locale("es").format("LL"),
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              }),
            ],
          ],
        },
      },
      {
        text: "Configuración de Listas de Precios",
        style: "tableHeaderIzquierda",
      },
      { text: "Configuracion general:", margin: [0, 6, 0, 0] },
      {
        style: "tableExample",
        table: {
          widths: ["22%", "28%", "22%", "28%"],
          body: filasConfiguracion,
        },
        layout: {
          hLineWidth: function () { return 1; },
          vLineWidth: function () { return 1; },
          hLineColor: function () { return "#adaaaa"; },
          vLineColor: function () { return "#adaaaa"; },
        },
      },
      { text: "Listas de precios:", margin: [0, 6, 0, 0] },
      {
        style: "tableExample",
        table: {
          headerRows: 1,
          widths: ["13%", "6%", "8%", "8%", "7%", "7%", "9%", "13%", "8%", "12%", "9%"],
          body: [encabezadoListas, ...filasListas],
        },
        layout: layoutTabla,
      },
      ...contenidoReglas,
      { text: "Escalas por cantidad:", margin: [0, 6, 0, 0] },
      {
        style: "tableExample",
        table: {
          headerRows: 1,
          widths: ["20%", "30%", "16%", "16%", "18%"],
          body: [
            [
              { text: "Lista", style: "tituloTabla" },
              { text: "Aplica a", style: "tituloTabla" },
              { text: "Desde", style: "tituloTabla" },
              { text: "Hasta", style: "tituloTabla" },
              { text: "Descuento maximo", style: "tituloTabla" },
            ],
            ...filasEscalas,
          ],
        },
        layout: layoutTabla,
      },
      { text: "Marcas sin calculo automatico de precios:", margin: [0, 6, 0, 0] },
      {
        style: "tableExample",
        table: {
          headerRows: 1,
          widths: ["25%", "75%"],
          body: [
            [
              { text: "Clave", style: "tituloTabla" },
              { text: "Marca", style: "tituloTabla" },
            ],
            ...filasMarcas,
          ],
        },
        layout: layoutTabla,
      },
    ],
    images: {
      logo: empresa.logo.base64Completa,
      logoBiwo: logoBiwo.base64Completa,
    },
    styles: {
      tableHeaderIzquierda: { bold: true, fontSize: 16, color: "black" },
      header: { fontSize: 9, bold: true },
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      textoChico: { fontSize: 8 },
      tituloTabla: {
        fontSize: 8,
        bold: true,
        fillColor: "#cccccc",
        alignment: "center",
      },
      textoTabla: { fontSize: 7, italics: false },
    },
    pageSize: "LETTER",
    pageOrientation: "landscape",
    pageMargins: [20, 20, 20, 50],
  };

  return dd;
};

export default configuracionListasDePreciosPdf;
